import { type CampaignId } from '../schema/CampaignId';
import { type PlacementId } from '../schema/PlacementId';
import type { MiniHostAppCampaign } from '../schema/MiniHostAppCampaign';

export const outlookLiteCampaignConfigs: MiniHostAppCampaign[] = [
    '88000759',
    '88000522',
    '73',
    '70',
    '90',
    '89',
    '91',
    '85',
    '221',
    '222',
    '223',
    '224',
    '84',
    '83',
    '92',
    '87',
    '121',
    '122',
    '123',
    '124',
    '125',
    '126',
    '127',
    '128',
    '129',
    '140',
    '150',
    '151',
    '201',
    '202',
    '203',
    '204',
    '205',
    '206',
    '207',
    '208',
    '209',
    '210',
    '211',
    '212',
    '213',
    '214',
    '215',
];
